/**
 * Social Sharing — Copy Link handler
 * Uses canonical URL from data-url attribute (not window.location.href)
 */
(function () {
  const COPIED_CLASS = 'social-sharing__link--copied';
  const COPIED_DURATION = 2000;
  const resetTimers = new WeakMap();

  function markCopied(button) {
    const previousTimer = resetTimers.get(button);
    if (previousTimer) clearTimeout(previousTimer);

    const originalLabel = button.getAttribute('aria-label');
    button.classList.add(COPIED_CLASS);
    button.setAttribute('aria-label', button.dataset.copiedLabel || 'Copied!');

    const timer = setTimeout(function () {
      button.classList.remove(COPIED_CLASS);
      button.setAttribute('aria-label', originalLabel);
      resetTimers.delete(button);
    }, COPIED_DURATION);
    resetTimers.set(button, timer);
  }

  document.addEventListener('click', function (e) {
    const button = e.target.closest('.js-copy-link');
    if (!button) return;

    e.preventDefault();
    const url = button.dataset.url;
    if (!url) return;

    navigator.clipboard.writeText(url).then(function () {
      markCopied(button);
    }).catch(function () {
      const textarea = document.createElement('textarea');
      textarea.value = url;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'absolute';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      markCopied(button);
    });
  });
})();
